import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Delivery, DeliveryStatus } from 'src/app/models/delivery.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';

@Component({
  selector: 'app-delivered-delivery',
  templateUrl: './delivered-delivery.component.html',
  styleUrls: ['./delivered-delivery.component.scss']
})
export class DeliveredDeliveryComponent implements OnInit {
  
  delivery: Delivery;
  loading = false;

  constructor(
    private deliveryService: DeliveryService,
    private route: ActivatedRoute,
    private commanUsesService: CommanUsesService,
  ) { }

  async ngOnInit() {
    try {
      this.loading = true;

      const token = this.route.snapshot.params['token'];

      this.delivery = await this.deliveryService.getDeliveryByMarkDeliveredToken(token);

      if (!this.delivery) {
        this.commanUsesService.showSnackBar('Consegna non trovata o link non valido');
        return;
      }

      if (this.delivery.status === DeliveryStatus.delivered) {
        this.commanUsesService.showSnackBar('Questa consegna è già stata consegnata');
        return;
      }

      if (confirm('Vuoi davvero impostare la consegna come consegnata?')) {
        this.delivery = await this.deliveryService.markDelivered(this.delivery.id);
        this.commanUsesService.showSnackBar('Consegna consegnata con successo');
      }
    } catch (error: any) {
      const errorMessage = this.getBackendErrorMessage(error);
      this.commanUsesService.showSnackBar(errorMessage);
      console.log('DeliveredDeliveryComponent error:', error);
    } finally {
      this.loading = false;
    }
  }

  private getBackendErrorMessage(error: any): string {
    if (error?.error?.message) {
      if (Array.isArray(error.error.message)) {
        return error.error.message.join(', ');
      }

      return error.error.message;
    }

    if (typeof error?.error === 'string') {
      return error.error;
    }

    if (error?.message) {
      return error.message;
    }

    return 'Errore nel recupero della consegna';
  }
}